"use strict";
// import { live,getCookie } from './tools';
// import {getUrlParam} from './urlMethod';
// import {is58App} from './appTools'
// export interface Ibase{
//     pageType?:string;
//     actionType?:string;
//     params?:any;
//     cate?:string;
// };
// export interface ItrackOpts extends Ibase{
//     json?:any;
// };
// type IwbLog=(opts:Ibase)=>void;
// export const wubaLog:IwbLog= ({ pageType = "default", actionType = "show", params = [], cate = "4,398038" }={}) => {
//         var ua = navigator.userAgent.toLowerCase(),
//             trackOpts:ItrackOpts = {params:params,cate:cate};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendClickStatistics = exports.aClickStatistics = exports.wubaLog = void 0;
//         let fromStr=getUrlParam('from')?getUrlParam('from'):getCookie('from_code');
//         if(actionType=='show'){
//             let objStr={from_code:fromStr};
//             trackOpts.json=objStr
//         }
//         if (is58App() && typeof(WBAPP) != "undefined") {
//             WBAPP.action.setWeblog(pageType, actionType, trackOpts)
//         }
//     };
//     /**
//      * 微动态A元素绑定埋点统计
//      */
// export const aClickStatistics = () => {
//         live(document, 'a', 'click', (dom) => {
//             sendClickStatistics(dom);
//         })
//     };
//     /**
//      * 发送58app点击埋点统计
//      * @param {dom} dom
//      */
// export const sendClickStatistics = (dom:HTMLElement) => {
//     let pageType = dom.getAttribute('data-pagetype'),
//         actionType = dom.getAttribute('data-actiontype'),
//         params:any[] = [],
//         paramStr = dom.getAttribute('data-params');
//     if (paramStr) {
//         let arr = paramStr.toString().split('|');
//         arr.length > 0 && arr.map(item => {
//             //@ts-ignore
//             if (!isNaN(item)) {
//                 params.push(`param-${item}`)
//             } else {
//                 params.push(item)
//             }
//         })
//     }
//     //paramStr && params.push(parseFloat(paramStr).toString() == "NaN" ? paramStr : 'param-' + paramStr);
//     if (pageType && actionType) {
//         wubaLog({pageType,actionType: actionType + '-click',params});
//     }
// };
var wubaLog_1 = require("../appMethods/wubaLog");
Object.defineProperty(exports, "wubaLog", { enumerable: true, get: function () { return wubaLog_1.wubaLog; } });
Object.defineProperty(exports, "aClickStatistics", { enumerable: true, get: function () { return wubaLog_1.aClickStatistics; } });
Object.defineProperty(exports, "sendClickStatistics", { enumerable: true, get: function () { return wubaLog_1.sendClickStatistics; } });
